const UNPUBLISH_TYPE = {
  ALL_LOTS: 'all_lots',
  ALL_IGNORED_LOTS: 'all_ignored_lots',
  ALL_LP_IGNORED_LOTS: 'all_lp_ignored_lots',
};

export { UNPUBLISH_TYPE };
